import { render, staticRenderFns } from "./school-area.vue?vue&type=template&id=6d165e5b"
import script from "./school-area.vue?vue&type=script&lang=js"
export * from "./school-area.vue?vue&type=script&lang=js"
import style0 from "./school-area.vue?vue&type=style&index=0&id=6d165e5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports